import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.sync-and-prov-scim', {
        url: '/sync-and-prov-scim',
        component: 'companyDirectoryIntegrationManageSyncAndProvScim',
        resolve: {
            directoryStatus,
        },
    });
}

/** @ngInject */
function directoryStatus(companyId, directory, DirectoriesResource) {
    return DirectoriesResource.getDirectoryStatus(companyId, directory);
}




// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/scim/sync-and-prov/directory-manage-sync-and-prov-scim.state.js